module.exports = __webpack_public_path__ + "bg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bg.svg
// module id = 700
// module chunks = 0